import { useQuery } from '@tanstack/react-query';
import { APP_VERSION_CONTROL_LIST } from 'src/constants/queryKeys';
import axiosInstance from 'src/utils/axios';

export const networkGetAppVersionControlInfo = async (appVersionControlId) => {
  const res = await axiosInstance.post(`AppVersionControl/Info/${appVersionControlId}`);
  return res;
};

export const networkGetAppVersionControlList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`AppVersionControl/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchAppVersionControlList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [APP_VERSION_CONTROL_LIST, payload, pageIndex],
    queryFn: () => networkGetAppVersionControlList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateAppVersionControl = async (appVersionControlId, payload) => {
  const res = await axiosInstance.post(`AppVersionControl/Update/${appVersionControlId}`, payload);
  return res;
};

export const networkRemoveAppVersionControl = async (appVersionControlId) => {
  const res = await axiosInstance.post(`AppVersionControl/Remove/${appVersionControlId}`);
  return res;
};

export const networkCreateAppVersionControl = async (payload) => {
  const res = await axiosInstance.post('AppVersionControl/Insert', payload);
  return res;
};
